import Icon from '@platform-ui-common/components/Icon/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import { ReactNode } from 'react';

interface VerifiedPortalProps {
  children: ReactNode;
}

export default function VerifiedPortal({ children }: VerifiedPortalProps): JSX.Element {
  return (
    <div
      className="flex flex-col text-center w-full gap-4 self-center items-center
                 md:w-1/2 md:text-left md:flex-row md:items-start"
    >
      <Icon type="verifiedOutlined" size="LG" />
      <Typography variant="body">{children}</Typography>
    </div>
  );
}
